import type { Story } from '@prezly/sdk';
import type { IndexedStory, IndexedStorySection } from '@prezly/theme-kit-core';
import { getStoryPublicationDate } from '@prezly/theme-kit-core';
import { FormattedDate } from 'react-intl';

interface Props {
    story: Story | IndexedStorySection;
}

function StoryPublicationDate({ story }: Props) {
    const date =
        typeof story.published_at === 'number'
            ? getStoryPublicationDate(story as IndexedStory)
            : getStoryPublicationDate({ published_at: story.published_at });

    if (!date) {
        return null;
    }

    return <FormattedDate value={date} year="numeric" month="long" day="numeric" />;
}

export default StoryPublicationDate;
